import { type ReactNode } from 'react'
import { Select, Input } from './ui'

interface FilterBarProps {
  children: ReactNode
  right?: ReactNode
}
export function FilterBar({ children, right }: FilterBarProps) {
  return (
    <div className="mb-4 flex flex-col sm:flex-row gap-2 sm:items-center">
      <div className="flex flex-wrap gap-2 flex-1">{children}</div>
      {right && <div className="flex gap-2">{right}</div>}
    </div>
  )
}

interface FilterSelectProps<T extends string | number> {
  value: T
  onChange: (v: T) => void
  options: { value: T; label: string }[]
  placeholder?: string
  className?: string
}
export function FilterSelect<T extends string | number>({ value, onChange, options, className }: FilterSelectProps<T>) {
  return (
    <div className={`min-w-[160px] ${className || ''}`}>
      <Select value={value as any} onChange={(e) => onChange((typeof value === 'number' ? +e.target.value : e.target.value) as T)}>
        {options.map((o) => <option key={String(o.value)} value={o.value as any}>{o.label}</option>)}
      </Select>
    </div>
  )
}

interface SearchInputProps {
  value: string
  onChange: (v: string) => void
  placeholder?: string
  className?: string
}
export function SearchInput({ value, onChange, placeholder, className }: SearchInputProps) {
  return (
    <div className={`relative ${className || 'min-w-[220px]'}`}>
      <svg className="absolute left-2.5 top-1/2 -translate-y-1/2 text-neutral-400"
           width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round">
        <circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/>
      </svg>
      <Input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className="pl-8" />
      {value && (
        <button onClick={() => onChange('')} className="absolute right-2 top-1/2 -translate-y-1/2 text-neutral-400 hover:text-neutral-700">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
      )}
    </div>
  )
}
